import { call, put } from 'redux-saga/effects';
import api from '../../services/api';
import { Creators as DadosClienteAction } from '../ducks/dados-cliente';
import DADOS_SIM from './../../consts/consts';
import { extractErrorFromResponse } from '../../assets/js/function-utils';

export function* buscaAgencia(action) {
    const formDadosCliente = DADOS_SIM.DADOS_CLIENTE;
    try {
        const { data } = yield call(api.get, `/agencia-bancaria/${action.payload[formDadosCliente.NUMERO_AGENCIA]}`);
        let dataResponse;
        if (data) {
            if (data.status === 'OK') {
                dataResponse = {
                    [formDadosCliente.NOME_AGENCIA]: data.resultado[formDadosCliente.NOME_AGENCIA]
                };
            } else if (data.status === 'Not Found') {
                dataResponse = {
                    [formDadosCliente.NOME_AGENCIA]: data.erros.erro
                };
            }
        } else {
            yield put(DadosClienteAction.buscaAgenciaFailure('Erro ao se comunicar com o servidor'));
        }

        yield put(DadosClienteAction.buscaAgenciaSuccess(dataResponse));
    } catch (err) {
        yield put(DadosClienteAction.buscaAgenciaFailure(extractErrorFromResponse(err)));
    }
}
